import { BaseQuery } from '../../../BaseQuery';
import { IExecutionOptions } from '../../../../models/query';
import { IQueryOptionsExternalApiDxmList } from '../../../../models/query/options/externalApi/dxm';
import { IDxmListResponse } from '../../../../models/portal/externalApi/providers/dxm';
import { get } from '../../../../utils';

export class DxmList extends BaseQuery<IQueryOptionsExternalApiDxmList> {
	getOptions(): IQueryOptionsExternalApiDxmList {
		const { options = {} } = this.queryOptions;
		return (
			options.externalApi &&
			options.externalApi.options &&
			options.externalApi.options.dxm &&
			options.externalApi.options.dxm.list
		);
	}

	get listResponse(): IDxmListResponse {
		const externalApiOptions = this.queryOptions.options && this.queryOptions.options.externalApi;
		const externalApiResponse = this.getExternalApiResponse(externalApiOptions, this.executionOptions);
		return externalApiResponse && externalApiResponse.dxm && externalApiResponse.dxm.list;
	}

	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		let rawValue: any = undefined;
		this.executionOptions = executionOptions;
		const response = this.listResponse;
		const options = this.options;
		if (options && response && response.values) {
			rawValue = response.values;
			const { index, path } = options;
			if (typeof index === 'number') {
				if (response.values.length > index) {
					rawValue = response.values[index];
					if (path) {
						rawValue = get(rawValue, path);
					}
				} else {
					rawValue = undefined;
				}
			}
		}
		return rawValue;
	}

	public executionOptions: IExecutionOptions | undefined;
}
